const styles = {
  /**
   * root wraps the whole app and these are therefore
   * the default styles
   */
  root: {
    fontFamily: "body",
    fontWeight: "light",
    fontSize: 0,
    lineHeight: 3,
    color: "ui.black"
  }
};

export default styles;
